<div class="validation-form-modal">
    <div>@if(currentPage !== 7){
        <div class="validation-form-modal-header">
            <p class="title">
                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                {{ "validationForm.validationModalTitle" | translate }}
                }@else{
                {{ getConsultantLabel('validationModalTitle') }}
                }
            </p>
            <app-icon-button [buttonIcon]="'close'" [type]="'floating'" (click)="activeModal.close()"></app-icon-button>
        </div>
        }
        <div class=" d-flex justify-content-end">
            @if(currentPage === 7){
            <app-icon-button [buttonIcon]="'close'" [type]="'floating'"
                (click)="activeModal.close(ValidationFormAnswerStateEnum.Answered)"></app-icon-button>
            }
        </div>
        <div class="validation-form-modal-body">
            <div class="validation-form-modal-container">
                @if (currentPage !== 5 && currentPage !== 6 && currentPage !== 7) {
                <div class="progress-bar-container">
                    @if (currentPage === 1) {
                    <img src="assets/images/progress1-of-4.svg" alt="Progress bar1" class="progress-bar" />
                    } @else if (currentPage === 2) {
                    <img src="assets/images/progress2-of-4.svg" alt="Progress bar2" class="progress-bar" />
                    } @else if (currentPage === 3) {
                    <img src="assets/images/progress3-of-4.svg" alt="Progress bar3" class="progress-bar" />
                    } @else if (currentPage === 4) {
                    <img src="assets/images/progress4-of-4.svg" alt="Progress bar4" class="progress-bar" />
                    }

                    <div class="form-progress-text">
                        <p [ngClass]="{ 'font-bold': currentPage === 1 }">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.taskDetails" | translate }}
                            }@else{
                            {{getConsultantLabel('taskDetails')}}
                            }

                        </p>
                        <p [ngClass]="{ 'font-bold': currentPage === 2 }">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.general" | translate }}
                            }@else{
                            {{getConsultantLabel('general')}}
                            }

                        </p>
                        <p [ngClass]="{ 'font-bold': currentPage === 3 }">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.assessment" | translate }}
                            }@else{
                            {{getConsultantLabel('assessment')}}
                            }

                        </p>
                        <p [ngClass]="{ 'font-bold': currentPage === 4 }">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.references" | translate }}
                            }@else{
                            {{getConsultantLabel('references')}}
                            }

                        </p>
                    </div>
                </div>
                }

                <!-- @if (validationAnswerForm) {
                <form id="validation-form" [formGroup]="validationAnswerForm"> -->
                <!-- Task info section -->
                <div [ngClass]="{ 'form-container': currentPage!==5 && currentPage!==6 && currentPage!==7}">
                    @if (currentPage === 1) {
                    <div class="validation-form-info-section">
                        <p class="sub-heading">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.taskDetails" | translate }}
                            }@else{
                            {{getConsultantLabel('taskDetails')}}
                            }
                        </p>

                        <div class="row">
                            <div class="col-7">
                                <div class="row">
                                    <p class="col-4 label-title">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.customer" | translate }}
                                        }@else{
                                        {{getConsultantLabel('customer')}}
                                        }

                                    </p>
                                    <p class="col-8">
                                        {{
                                        taskAssociatedToValidationForm?.customer
                                        }}
                                    </p>
                                </div>
                                <div class="row mt-2">
                                    <p class="col-4 label-title">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "validationForm.role" | translate }}
                                        }@else{
                                        {{getConsultantLabel('role')}}
                                        }
                                    </p>
                                    <app-content-translater class="col-8 label-value" [content]="consultantForTask"
                                        [notBold]="true"></app-content-translater>
                                </div>
                                <div class="row mt-2">

                                    <p class="col-4 label-title">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{
                                        "validationForm.startDate"
                                        | translate
                                        }}
                                        }@else{
                                        {{getConsultantLabel('startDate')}}
                                        }
                                    </p>


                                    <p class="col-8">
                                        {{ taskAssociatedToValidationForm?.startDate | date : dateFormatEnum.OnlyDate }}
                                    </p>
                                </div>
                                <div class="row mt-2">
                                    <p class="col-4 label-title">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{
                                        "validationForm.timePerWeek"
                                        | translate
                                        }}
                                        }@else{
                                        {{getConsultantLabel('timePerWeek')}}
                                        }

                                    </p>
                                    <p class="col-8">
                                        {{
                                        taskAssociatedToValidationForm?.hours
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="row mt-2">

                                    <p class="col-6 label-title">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.location" | translate }}
                                        }@else{
                                        {{getConsultantLabel('location')}}
                                        }
                                    </p>

                                    <p class="col-6">
                                        {{
                                        taskAssociatedToValidationForm?.location
                                        }}
                                    </p>
                                </div>
                                <div class="row mt-2">

                                    <p class="col-6 label-title">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{
                                        "labels.languageRequirement"
                                        | translate
                                        }}
                                        }@else{
                                        {{getConsultantLabel('languageRequirement')}}
                                        }


                                    </p>

                                    <p class="col-6">
                                        {{
                                        taskAssociatedToValidationForm?.languageRequirement
                                        }}
                                    </p>
                                </div>
                                <div class="row mt-2">
                                    <p class="col-6 label-title">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{
                                        "validationForm.endDate" | translate
                                        }}}@else{
                                        {{getConsultantLabel('endDate')}}
                                        }

                                    </p>
                                    <p class="col-6">
                                        {{
                                        taskAssociatedToValidationForm?.endDate
                                        | date : dateFormatEnum.OnlyDate
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- task description -->
                        <p class="label-title">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.taskDescription" | translate }}:
                            }@else{
                            {{getConsultantLabel('taskDescription')}}
                            }

                        </p>
                        <div class="quill-task-desc">
                            @if(taskAssociatedToValidationForm &&taskAssociatedToValidationForm.description) {
                            <quill-view [content]="taskAssociatedToValidationForm.description"
                                ></quill-view>
                            }
                        </div>
                        <!-- task skills -->
                        <p class="label-title">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "labels.competenceRequirements" | translate }}:
                            }@else{
                            {{getConsultantLabel('competenceRequirements')}}
                            }

                        </p>
                        <div class="d-flex gap-2">
                            <div class="task-skills-container">
                                @for (taskSkill of taskAssociatedToValidationForm?.taskSkills; track taskSkill.id) {
                                <div class="task-skill">
                                    {{ taskSkill.skill }}
                                </div>
                                }
                            </div>
                        </div>

                        <!-- payment conditions -->
                        @if(paymentConditions) {
                        <p class="label-title">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{
                            "validationForm.paymentConditions" | translate
                            }}:
                            }@else{
                            {{getConsultantLabel('paymentConditions')}}
                            }

                        </p>

                        <p>{{ paymentConditions }}</p>


                        <!--Payment accept decline-->
                        <div class="mt-2">
                            <input type="radio" id="accept" [value]="true" [(ngModel)]="paymentConditionsAccepted" />
                            <label class="pl-2 label-title" for="accept">
                                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                {{ "labels.accept" | translate }}
                                }@else{
                                {{getConsultantLabel('accept')}}
                                }

                            </label>
                            <input class="ml-4" type="radio" id="decline" [value]="false"
                                [(ngModel)]="paymentConditionsAccepted" />
                            <label class="pl-2 label-title" for="decline">
                                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                {{ "labels.decline" | translate }}
                                }@else{
                                {{getConsultantLabel('decline')}}
                                }

                            </label>
                        </div>
                        }
                    </div>

                    } @if (currentPage === 2) {

                    <div class="general-info">
                        <div class="row">
                            <div class="col-5">
                                <div class="row">
                                    <p class="col-3 label-title mb-3">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.email" | translate }}
                                        }@else{
                                        {{getConsultantLabel('email')}}
                                        }

                                    </p>
                                    <p class="col-9 mb-3">
                                        {{ profileInfo?.email || accessToken?.email }}
                                    </p>
                                    <p class="col-3 label-title mb-3">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.name" | translate }}
                                        }@else{
                                        {{getConsultantLabel('name')}}
                                        }

                                    </p>
                                    <div class="col-9 mb-3">
                                        @if(accessToken?.email){
                                        <input type="text" class="form-control" [(ngModel)]="accessTokenName"
                                            [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.name' | translate) : getConsultantLabel('name')"
                                            [ngClass]="{ 'invalid': (!accessTokenName || accessTokenName.trim() === '') }" />
                                        }@else{
                                        @if(profileInfo && profileInfo?.firstname && profileInfo?.surname) {
                                        {{ profileInfo.firstname }}
                                        {{ profileInfo.surname }}
                                        }
                                        }

                                    </div>
                                    <p class="col-3 picture label-title mb-3">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.picture" | translate }}
                                        }@else{
                                        {{getConsultantLabel('picture')}}
                                        }

                                    </p>
                                    <div class="col-9 img-container mb-3">

                                        @if (selectedImagePath) {
                                        <div class="d-flex align-items-center gap-2">
                                            <app-profile-image [imagePath]="'/Images/' + selectedImagePath"
                                                [width]="200" [isCard]="true">
                                            </app-profile-image>
                                            <label>
                                                <img [src]="'assets/icons/edit.svg'" alt="icon"
                                                    class="icon-btn-small" />
                                                <input #file type="file" id="image" class="fileuploadform"
                                                    onclick="this.value=null" (change)="onSelectFile($event)" />
                                            </label>
                                        </div>
                                        } @else {
                                        <label class="btn btn-primary">
                                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                            {{ 'labels.uploadPic' | translate }}
                                            }@else{
                                            {{getConsultantLabel('uploadNewPicture')}}
                                            }

                                            <input type="file" accept="image/*" (change)="onSelectFile($event)"
                                                hidden />
                                        </label>
                                        }
                                    </div>
                                </div>
                            </div>

                            <!-- MOTIVATION -->
                            <div class="col-7">
                                <p class="label-title mb-3 ml-3">
                                    @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                    {{
                                    "validationForm.personalMotivation"
                                    | translate
                                    }}
                                    }@else{
                                    {{getConsultantLabel('pe.rsonalMotivation')}}
                                    }

                                </p>

                                <div class="quill-editor-container">
                                           <quill-editor [modules]="modules" format="html" [(ngModel)]="personalMotivation"
                                        [placeholder]="
                                        currentUser?.userRoleEnumDto === UserRoleEnum.Admin
                                            ? ('validationForm.personalMotivationPlaceholder' | translate)
                                            : getConsultantLabel('personalMotivationPlaceholder')
                                    "
                                    >
                                    </quill-editor>
                                </div>

                            </div>
                        </div>
                        <p class="sub-heading">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.general" | translate }}
                            }@else{
                            {{getConsultantLabel('general')}}
                            }
                        </p>

                        <div class="row">
                            @for(field of generalFormFields; track field?.id) {
                            <p class="col-5 mt-3">{{ field?.name }}</p>
                            @if(field.inputType === inputTypeEnum.Text) {
                            <div class="col-7 mt-3">
                                <input type="text" [(ngModel)]="answersByFieldId[field.id]" (ngModelChange)="
                                        onValueChange(field, $event)
                                    " name="field_{{ field.id }}"
                                    [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.writeHere' | translate) : getConsultantLabel('writeHere')" />
                            </div>
                            } @if(field.inputType === inputTypeEnum.DatePicker)
                            {
                            <div class="col-7 mt-3">
                                <input type="text" class="task-datepicker task-datepicker--full"
                                    placeholder="dd-mm-yyyy" [(ngModel)]="answersByFieldId[field.id]" ngbDatepicker
                                    #dl="ngbDatepicker" [readonly]="true" (click)="dl.toggle()" (ngModelChange)="
                                    onValueChange(field, $event)
                                " />
                            </div>
                            }
                            @if(field.inputType === inputTypeEnum.RadioButton) {
                            <div class="col-7 mt-3 d-flex gap-3">
                                <div>
                                    <input type="radio" [name]="'field_' + field.id" [id]="'field_' + field.id + '_yes'"
                                        [(ngModel)]="answersByFieldId[field.id]" [value]="true" />
                                    <label class="form-check-label" [for]="'field_' + field.id + '_yes'">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.yes" | translate }}
                                        }@else{
                                        {{ getConsultantLabel('yes') }}
                                        }
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" [name]="'field_' + field.id" [id]="'field_' + field.id + '_no'"
                                        [(ngModel)]="answersByFieldId[field.id]" [value]="false" />
                                    <label class="form-check-label" [for]="'field_' + field.id + '_no'">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.no" | translate }}
                                        }@else{
                                        {{ getConsultantLabel('no') }}
                                        }
                                    </label>
                                </div>
                            </div>
                            }
                            }
                        </div>
                    </div>
                    } @if(currentPage === 3) {
                    <div class="rating-form">
                        @if(this.categories.includes("qualities")){
                        <p class="sub-heading">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.qualities" | translate }}
                            }@else{
                            {{getConsultantLabel('qualities')}}
                            }

                            <span class="ml-2"
                                [ngbTooltip]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('validationForm.qualitiesToolTip' | translate) : getConsultantLabel('qualitiesToolTip')"><img
                                    [src]="'assets/images/tooltip.svg'" alt="icon" /></span>
                        </p>
                        }
                        @for(field of ratingFormFields; track field.id) {
                        @if(field.category==="qualities") {

                        <div class="row">
                            <p class="label-title col-5 mt-3">{{ field.name }}</p>

                            @if(field.inputType === inputTypeEnum.OneToFiveScale) {
                            <div class="col-7 mt-3 rating-container">
                                @for (rating of [1, 2, 3, 4, 5]; track rating) {
                                <div class="rating-bar" [ngClass]="{
                                    'rating-bar__filled':
                                        rating <=
                                        +(answersByFieldId[field.id] ?? 0),
                                    'rating-bar__outlined':
                                        rating >
                                        +(answersByFieldId[field.id] ?? 0)
                                }" (click)="setRating(field, rating)"></div>
                                }
                            </div>
                            }
                            @if(field.inputType === inputTypeEnum.Text) {
                            <div class="col-7 mt-3">
                                <input type="text" [(ngModel)]="answersByFieldId[field.id]" (ngModelChange)="
                                        onValueChange(field, $event)
                                    " name="field_{{ field.id }}"
                                    [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.writeHere' | translate) : getConsultantLabel('writeHere')" />
                            </div>
                            }
                            @if(field.inputType === inputTypeEnum.YearSelector) {
                            <div class="col-7 mt-3">
                                <select [(ngModel)]="answersByFieldId[field.id]" (ngModelChange)="
                                        onValueChange(field, $event)
                                    " class="task-select task-select--half">
                                    <option [ngValue]="null" data-default>
                                        {{ "labels.chooseAmount" | translate }}
                                    </option>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option selected="selected" value="5">5</option>
                                    <option value="6">5+</option>
                                    <option value="11">10+</option>
                                    <option value="21">20+</option>
                                </select>
                            </div>
                            }

                        </div>

                        } }


                        @if(this.categories.includes("experience")){
                        <p class="sub-heading mt-3">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.expereince" | translate }}
                            }@else{
                            {{getConsultantLabel('experience')}}
                            }
                            <span class="ml-2"
                                [ngbTooltip]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('validationForm.experienceToolTip' | translate) : getConsultantLabel('experienceToolTip')"><img
                                    [src]="'assets/images/tooltip.svg'" alt="icon" /></span>

                        </p>
                        } @for(field of ratingFormFields; track field.id) {
                        @if(field.category==="experience") {

                        <div class="row">
                            <p class="label-title col-5 mt-3">{{ field.name }}</p>

                            @if(field.inputType === inputTypeEnum.OneToFiveScale) {
                            <div class="col-7 mt-3 rating-container">
                                @for (rating of [1, 2, 3, 4, 5]; track rating) {
                                <div class="rating-bar" [ngClass]="{
                                    'rating-bar__filled':
                                        rating <=
                                        +(answersByFieldId[field.id] ?? 0),
                                    'rating-bar__outlined':
                                        rating >
                                        +(answersByFieldId[field.id] ?? 0)
                                }" (click)="setRating(field, rating)"></div>
                                }
                            </div>
                            }
                            @if(field.inputType === inputTypeEnum.Text) {
                            <div class="col-7 mt-3">
                                <input type="text" [(ngModel)]="answersByFieldId[field.id]" (ngModelChange)="
                                        onValueChange(field, $event)
                                    " name="field_{{ field.id }}"
                                    [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.writeHere' | translate) : getConsultantLabel('writeHere')" />
                            </div>
                            }
                            @if(field.inputType === inputTypeEnum.YearSelector) {
                            <div class="col-7 mt-3">
                                <select [(ngModel)]="answersByFieldId[field.id]" (ngModelChange)="
                                        onValueChange(field, $event)
                                    " class="task-select task-select--half">
                                    <option [ngValue]="null" data-default>
                                        {{ "labels.chooseAmount" | translate }}
                                    </option>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option selected="selected" value="5">5</option>
                                    <option value="6">5+</option>
                                    <option value="11">10+</option>
                                    <option value="21">20+</option>
                                </select>
                            </div>
                            }

                        </div>


                        } }
                    </div>
                    } @if(currentPage === 4) {

                    <!--REFERENCES SECTION-->
                    <div class="reference-section">
                        <p class="sub-heading mb-3">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "labels.references" | translate }}
                            }@else{
                            {{getConsultantLabel('references')}}
                            }

                        </p>

                        @for (reference of referencesList; track $index;let ind
                        = $index) {
                        <div class="d-flex justify-content-between hover-container"
                            [ngClass]="{ selectedRef: editingIndex === ind }">
                            <p>{{ reference.name }}</p>
                            <div class="d-flex gap-3">
                                <app-icon-button [size]="'small'" [buttonIcon]="'edit'" [type]="'floating'"
                                    (clicked)="editReference(reference, ind)"></app-icon-button>

                                @if(editingIndex !== ind) {
                                <app-icon-button [size]="'small'" [buttonIcon]="'close'" [type]="'floating'"
                                    (clicked)="deleteReference(reference, ind)"></app-icon-button>

                                }
                            </div>
                        </div>

                        } @if(!hideAddReferenceBtn) {
                        <div class="mt-2">
                            <app-input-button type="floating" icon="add" (clicked)="handleShowReferenceForm()">
                                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                {{
                                "validationForm.addReferences" | translate }} }@else{
                                {{getConsultantLabel('addReferences')}}
                                }</app-input-button>


                        </div>
                        } @if(showReferenceForm){
                        <div class="row">
                            <p class="col-4 label-title mb-2">
                                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                {{ "labels.name" | translate }}
                                }
                                @else{
                                {{getConsultantLabel('name')}}
                                }
                            </p>
                            <div class="col-8 mb-2"> <input type="text"
                                    [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.writeHere' | translate) : getConsultantLabel('writeHere')"
                                    [(ngModel)]="referenceForm.name" /></div>

                            <p class="label-title col-4 mb-2">
                                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                {{ "labels.email" | translate }}
                                }
                                @else{
                                {{getConsultantLabel('email')}}
                                }
                            </p>
                            <div class="col-8 mb-2">
                                <input type="text"
                                    [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.writeHere' | translate) : getConsultantLabel('writeHere')"
                                    [(ngModel)]="referenceForm.mail" />
                            </div>
                            <p class="label-title col-4 mb-2">
                                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                {{ "labels.phone" | translate }}
                                }
                                @else{
                                {{getConsultantLabel('phone')}}
                                }
                            </p>
                            <div class="col-8 mb-2">
                                <input type="text"
                                    [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.writeHere' | translate) : getConsultantLabel('writeHere')"
                                    [(ngModel)]="referenceForm.phone" />
                            </div>
                            <p class="label-title col-4 mb-2">
                                @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                {{ "validationForm.referenceDescription" | translate }}
                                }
                                @else{
                                {{getConsultantLabel('referenceDescription')}}
                                }
                            </p>
                            <div class="col-8 mb-2">
                                <textarea class="form-control" [(ngModel)]="referenceForm.description" rows="4"
                                    [placeholder]="currentUser?.userRoleEnumDto === UserRoleEnum.Admin ? ('labels.writeHere' | translate) : getConsultantLabel('writeHere')"></textarea>
                                @if(referenceValidation) {
                                <p class="error mt-2">{{"validationForm.toastrMsgs.referenceValidation" |translate }}
                                </p>
                                }
                            </div>


                            <div class="d-flex w-100 justify-content-end mt-3">
                                <div class="d-flex gap-3">


                                    <app-input-button [type]="'outlined'" (clicked)="cancelEditing()">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "labels.cancel"
                                        | translate }}
                                        }@else{
                                        {{getConsultantLabel('cancel')}}
                                        }

                                    </app-input-button>
                                    <app-input-button [type]="'primary'" (clicked)="handleSaveReferences()">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{
                                        "labels.confirm" | translate }}
                                        }@else{
                                        {{getConsultantLabel('confirm')}}
                                        }

                                    </app-input-button>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }

                    @if(currentPage === 5) {
                    <!--SUMMARY SECTION-->


                    <div class="summary-section" [ngClass]="{ 'form-summary-container': currentPage }">
                        <p class="sub-heading mb-3">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.summary" | translate }}
                            }@else{
                            {{getConsultantLabel('summary')}}
                            }

                        </p>
                        <hr>

                        <div class="row">
                            <div class="d-flex justify-content-between">
                                <div class="w-100  row">
                                    <p class="label-title col-6 mb-2">
                                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                        {{ "validationForm.personalMotivation" | translate}}
                                        }@else{
                                        {{getConsultantLabel('personalMotivation')}}
                                        }

                                    </p>
                                    <div class="motivation-quill">
                                        <quill-view-html
                                            [content]="personalMotivation" class="quill-view"></quill-view-html>
                                    </div>
                                    <!-- <p class="col-6 my-2">{{ personalMotivation }}</p> -->
                                </div>
                                <app-icon-button [buttonIcon]="'edit'" size="small" [type]="'floating'"
                                    (clicked)="currentPage = 2"></app-icon-button>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between">
                                <p class="label-title  my-2">
                                    @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                    {{ "validationForm.general" | translate }}
                                    }@else{
                                    {{getConsultantLabel('general')}}
                                    }
                                </p>
                                <app-icon-button [buttonIcon]="'edit'" size="small" [type]="'floating'"
                                    (clicked)="currentPage = 2"></app-icon-button>

                            </div>
                            <div>
                                @for(field of summaryGeneralInfo; track field.id) {
                                <div class="row">
                                    <p class="col-6 mb-2">{{ field.label }}
                                    <p class="col-6 mb-2">{{ field.value }}</p>
                                </div>
                                }
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between">
                                <p class="label-title my-2">
                                    @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                    {{ "validationForm.assessment" | translate }}
                                    }@else{
                                    {{getConsultantLabel('assessment')}}
                                    }
                                </p>
                                <app-icon-button [buttonIcon]="'edit'" size="small" [type]="'floating'"
                                    (clicked)="currentPage = 3"></app-icon-button>

                            </div>
                            <div class="row">
                                @for(field of summaryRatingInfo; track field.id) {
                                <p class="col-6 mb-2">{{ field.label }}</p>
                                @if(field.inputType === inputTypeEnum.OneToFiveScale) {
                                <div class="col-6">
                                    <app-rating-bar [selectedRate]="field.value"></app-rating-bar>
                                </div>
                                }
                                @if(field.inputType === inputTypeEnum.Text) {
                                <div class="col-6">
                                    <p>{{ field.value }}</p>
                                </div>
                                }
                                @if(field.inputType === inputTypeEnum.YearSelector) {
                                <div class="col-6">
                                    {{ getYearDisplayValue(field.value) }} {{ "labels.year" | translate | lowercase }}
                                </div>
                                }

                                }
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between">
                                <p class="label-title my-2">
                                    @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                                    {{ "labels.references" | translate }}
                                    }@else {
                                    {{getConsultantLabel('references')}}}
                                </p>
                                <app-icon-button [buttonIcon]="'edit'" size="small" [type]="'floating'"
                                    (clicked)="currentPage = 4"></app-icon-button>

                            </div>
                            @for(field of referencesList; track $index) {
                            <p class="label-title mt-1">{{ field.name }}</p>
                            <p>{{ field.mail }}</p>
                            <p>{{ field.phone }}</p>
                            <p>{{ field.description }}</p>
                            }


                        </div>
                        @if(accessToken) {
                        <p class="mt-3">
                            {{ currentUser?.userRoleEnumDto === UserRoleEnum.Admin
                            ? ("validationForm.userCreation" | translate)
                            : getConsultantLabel('userCreation') }}
                            <a href="/assets/Privatlivspolitik_til_PITTEN_072025.pdf" target="_blank">
                                {{ currentUser?.userRoleEnumDto === UserRoleEnum.Admin
                                ? ("validationForm.privacyPolicyLink" | translate)
                                : getConsultantLabel('privacyPolicyLink') }}
                            </a>
                        </p>
                        }
                    </div>
                    }
                </div>
                @if(currentPage === 6) {
                <div class="confirm-modal-section">
                    <p class="sub-heading">{{ currentUser?.userRoleEnumDto === UserRoleEnum.Admin
                        ? ("validationForm.confirm-send" | translate)
                        : getConsultantLabel('confirmSend') }}</p>
                </div>
                }
                @if(currentPage === 7) {
                <div class="success-info ">
                    <div class="big-check">
                        <img src="assets/images/big-check.svg" alt="big-check">
                    </div>
                    <div class="success-text">
                        <p class="mt-3 sub-heading">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.validationFormSendSuccessTitle" | translate }}
                            }@else{
                            {{ getConsultantLabel('validationFormSendSuccessTitle') }}
                            }
                        </p>
                        <p class="pt-2">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.validationFormSendText" | translate }}
                            }@else{
                            {{ getConsultantLabel('validationFormSendText') }}
                            }
                        </p>
                        <p class="pt-4 text-center">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "validationForm.validationFormSendTip" | translate }}
                            }@else{
                            {{ getConsultantLabel('validationFormSendTip') }}
                            }
                        </p>
                    </div>
                </div>
                }

                @if (currentPage !== 7) {
                <div class="validation-form-modal-footer">

                    <!-- Back button (from page 2 onward) -->
                    @if (currentPage !== 1) {
                    <app-input-button type="outlined" (clicked)="gotoPreviousPage()">
                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                        {{ "labels.back" | translate }}
                        }@else{
                        {{getConsultantLabel('back')}}
                        }
                    </app-input-button>
                    } @else {
                    <div></div> <!-- Alignment spacer -->
                    }

                    <!-- Next button (pages 1–4) -->
                    @if (currentPage < 5) { <app-input-button type="primary" (clicked)="goToNextPage()">
                        @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                        {{ "labels.next" | translate }}
                        }@else{
                        {{getConsultantLabel('next')}}
                        }
                        </app-input-button>
                        }

                        <!-- Send button (page 5 only) -->
                        @if (currentPage === 5) {
                        <app-input-button type="primary" (clicked)="sendValidationFormAnswers()">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "labels.send" | translate }}
                            }@else{
                            {{getConsultantLabel('send')}}
                            }

                        </app-input-button>
                        }

                        <!-- Confirm button (page 6 only) -->
                        @if (currentPage === 6) {
                        <app-input-button type="primary" (clicked)="confirmSend()">
                            @if(currentUser?.userRoleEnumDto === UserRoleEnum.Admin) {
                            {{ "labels.confirm" | translate }}
                            }@else{
                            {{getConsultantLabel('confirm')}}
                            }

                        </app-input-button>
                        }

                </div>
                }


            </div>
            @if(currentPage!==1 && currentPage!==6 && currentPage!==7) {
            <div>
                <app-validation-modal-task-details [taskDetails]="taskAssociatedToValidationForm"
                    [validationFormLang]="this.validationForm?.lang" [paymentDetails]="paymentConditions"
                    [userEnum]="this.currentUser?.userRoleEnumDto"
                    [formTaskDescripion]="taskAssociatedToValidationForm.description"
                    [consultantForTask]="this.consultantForTask"></app-validation-modal-task-details>


            </div>
            }
        </div>
    </div>
</div>